import { modifier } from 'ember-modifier';
import autoAnimate from '@formkit/auto-animate';

export default modifier((element: HTMLElement) => {
  autoAnimate(element);
  // Return empty cleanup function
  return () => {};
}, { eager: false });